import SplitPanel from './split-panel';
export default SplitPanel;



// WEBPACK FOOTER //
// ./src/components/split-panel/index.js